import React, { useState, useEffect, useRef } from "react";
import { Edit2, Trash2, Upload } from "lucide-react";
import "./Brands.css";
import { adminApi } from "../../utils/adminApi";

const Brands = () => {
  const [brands, setBrands] = useState([]);
  const [brandInput, setBrandInput] = useState("");
  const [editingBrandId, setEditingBrandId] = useState(null);

  const [brandImage, setBrandImage] = useState(null);
  const [brandPreview, setBrandPreview] = useState(null);

  const brandFileRef = useRef(null);

  useEffect(() => {
    fetchBrands();
  }, []);

  const fetchBrands = async () => {
    try {
      const res = await adminApi.get("/api/brands");
      setBrands(res.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const fileToBase64 = (file) =>
    new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(file);
    });

  const saveBrand = async () => {
    if (!brandInput.trim()) return;

    let logoBase64 = "";
    if (brandImage) {
      logoBase64 = await fileToBase64(brandImage);
    }

    if (editingBrandId) {
      await adminApi.put(`/api/brands/${editingBrandId}`, {
        name: brandInput,
        ...(logoBase64 && { logo: logoBase64 }),
      });
      setEditingBrandId(null);
    } else {
      await adminApi.post("/api/brands", {
        name: brandInput,
        logo: logoBase64,
      });
    }

    setBrandInput("");
    setBrandImage(null);
    setBrandPreview(null);
    fetchBrands();
  };

  const editBrand = (brand) => {
    setBrandInput(brand.name);
    setBrandPreview(brand.logo);
    setEditingBrandId(brand._id);
  };

  const deleteBrand = async (id) => {
    if (!window.confirm("Delete brand?")) return;
    await adminApi.delete(`/api/brands/${id}`);
    fetchBrands();
  };

  return (
    <div className="inventory-page">
      <h1>Brand Management</h1>

      {/* FORM */}
      <div className="panel">
        <h3>Add / Update Brand</h3>

        <div
          className="drag-area"
          onClick={() => brandFileRef.current.click()}
        >
          {brandPreview ? (
            <img src={brandPreview} className="preview-img" alt="preview" />
          ) : (
            <>
              <Upload size={24} />
              <p style={{ color: "#0F52BA" }}>Select Brand Logo</p>
            </>
          )}
        </div>

        <input
          type="file"
          hidden
          ref={brandFileRef}
          accept="image/*"
          onChange={(e) => {
            setBrandImage(e.target.files[0]);
            setBrandPreview(URL.createObjectURL(e.target.files[0]));
          }}
        />

        <input
          type="text"
          placeholder="Brand Name"
          value={brandInput}
          onChange={(e) => setBrandInput(e.target.value)}
          className="text-input"

          style={{ marginTop: "15px",color:"#0F52BA" }}
          
        />

        <button className="primary-btn" onClick={saveBrand}>
          {editingBrandId ? "Update Brand" : "Add Brand"}
        </button>
      </div>

      {/* LIST */}
      <div className="panel">
        <h3>All Brands</h3>

        <ul className="brand-list">
          {brands.map((b) => (
            <li key={b._id} className="brand-item">
              <div className="item-content">
                <div className="left">
                  {b.logo && <img src={b.logo} alt={b.name} />}
                  <span>{b.name}</span>
                </div>

                <div className="action-icons">
  <button
    className="icon-btn edit"
    onClick={() => editBrand(b)}
  >
    <Edit2 size={16} />
  </button>

  <button
    className="icon-btn delete"
    onClick={() => deleteBrand(b._id)}
  >
    <Trash2 size={16} />
  </button>
</div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Brands;
